<template>
  <div>
    <app-header></app-header>
    <div class="container-fluid" style="background-color: white;">
      <div class="display-4">Downloads</div>
      <hr />
    </div>

    <div v-if="genericdownloadsloaded = true" class="container-fluid">
      <div class="card" v-for="d in downloads" v-bind:key="d.Id">
        <h5 class="card-header">{{d.fileName}}</h5>
        <div class="card-body">
          <div v-for="v in d.versions" v-bind:key="v.Id">
            <h5 class="card-title">{{v.displayName}}</h5>
            <p class="card-text">{{v.description}}</p>
            <a v-bind:href="v.link" target="_blank" class="btn btn-primary">Download</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from "../intro/AppHeader";
import store from "../../ClientApp/store";

export default {
  data: function() {
    return {
      genericdownloadsloaded: false
    };
  },
  methods: {
    downloadsList() {
      this.$router.push("/downloads");
    }
  },
  computed: {
    downloads() {
      return this.$store.getters.getGenericDownloads;
    }
  },
  mounted() {
    this.$store.dispatch("getGenericDownloads").then(response => {
      this.genericdownloadsloaded = true;
    });
  },
  components: {
    AppHeader
  }
};
</script>

<style scoped>
@media (min-width: 1500px) {
  .container-fluid {
    width: 80%;
  }
}
@media (min-width: 2000px) {
  .container-fluid {
    width: 60%;
  }
}
.lnk {
  cursor: pointer;
}

.centered-and-cropped {
  object-fit: contain;
}
</style>


// WEBPACK FOOTER //
// src/components/downloads/DownloadList.vue